import { navigateToUrl } from 'single-spa';
import { Button, CalendarOutlined } from 'core/components';
import { useCallback } from 'react';
import { t } from 'i18next';

type ActionsCalendarLinkProps = {
  path: string;
};

export function ActionsCalendarLink({ path }: ActionsCalendarLinkProps) {
  const onClick = useCallback(() => navigateToUrl(path), []);

  return (
    <Button
      tooltip={{ title: t('IssueTracker.OpenCalendar') }}
      icon={<CalendarOutlined />}
      onClick={onClick}
      type="link"
    />
  );
}
